export interface Incident {
  id: string
  name: string
  status: string
  url: string
  last_update_message: string
}

export interface StatusResponse {
  ongoing_incidents: Incident[]
}

const STATUS_URL = 'https://status-proxy.buffer.com'

export async function fetchStatusIncidents(): Promise<Incident[]> {
  try {
    const res = await fetch(STATUS_URL)
    // we knw the response type, so we cast here
    // eslint-disable-next-line
    const data = (await res.json()) as StatusResponse
    return data.ongoing_incidents || []
  } catch (e: unknown) {
    if (e instanceof Error) {
      // eslint-disable-next-line
      console.error(e.message)
    }
    return []
  }
}
